module.exports = __webpack_public_path__ + "Times_Education_Excellence_2021-b7ba6b9f.webp";